module.exports = __webpack_public_path__ + "static/img/resume_A.688b6ee.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/resume_A.jpeg
// module id = EVkb
// module chunks = 0